module.exports = "button.btn_agregar{max-width:171px}.agregar-subcategoria.modal{width:373px;height:359px}\n"